<script lang="ts">
  import { onDestroy } from 'svelte';
  import {
    Chart as ChartJS,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    LineController,
    BarController,
  } from 'chart.js';
  import { Chart } from 'svelte-chartjs';
  import loader from 'src/components/cabinet/#assets/loader.svg';
  import { optionsLinear } from '../../configs/BarOptions';
  import moment from 'moment';
  import { getRetentionAnalytics } from '../../../#services/retentionAnalytics';
  import Table from './../Table.svelte';

  const retentionCollectStartDate = moment('2023-09-06').format('YYYY-MM-DD');
  const retentionEndDate = moment().subtract(1, 'days').format('YYYY-MM-DD');

  let chart, table;

  const colors = ["#FF5D1C", "#14c8f5", "#1aeb74", "#FED049", "#DC3535", '#497174'];

  let onlyNewUsers = true;
  let creator = 'all';
  
  let labels = [];
  let datasets = [];

  let data = { labels, datasets };

  let startDate = 'startDate'
  let endDate = 'endDate'

  const minDate = retentionCollectStartDate;
  const maxDate = retentionEndDate;

  function setDate(days) {
    if (days > -1) {
      let d = new Date(maxDate);
      d.setDate(d.getDate() - days);
      let dd = String(d.getDate()).padStart(2, '0');
      let mm = String(d.getMonth() + 1).padStart(2, '0');
      let yyyy = d.getFullYear();
      startDate = yyyy+'-'+mm+'-'+dd;
      endDate = maxDate;
    } else {
      startDate = 'startDate';
      endDate = 'endDate';
    }
  }

  setDate(4);

  ChartJS.register(
    LinearScale,
    CategoryScale,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
  );

  function refresh() {
    let creators;
    if (creator !== 'all') creators = creator;

    const games = {
      'Cats': 3,
      'Dragons': 5,
      'Foxes': 7,
      'Dogs': 11,
    };

    let branchesData;

    if (creator === 'all') {
      branchesData = [
        {
          label: 'Cats',
          appId: 3,
        },
        {
          label: 'Dragons',
          appId: 5,
        },
        {
          label: 'Foxes',
          appId: 7,
        },
        {
          label: 'Dogs',
          appId: 11,
        },
      ];
    } else {
      branchesData = [
        {
          label: creators,
          appId: games[creators],
        },
      ];
    }

    let data: {
      branches: {
        label: string,
        appId: number,
      }[],
      onlyNewUsers: boolean,
      startDate?: string,
      endDate?: string
    } = { branches: branchesData, onlyNewUsers };

    data.startDate = minDate;
    data.endDate = maxDate;
    
    if (startDate && startDate !== 'startDate') {
      data.startDate = startDate;
    }

    if (endDate && endDate !== 'endDate') {
      data.endDate = endDate;
    }

    getRetentionAnalytics.send({ data });
  }

  onDestroy(() => {});

  refresh();

  getRetentionAnalytics.subscribe((value) => {
    if (value.hasValue && !value.error && !value.loading) {
      while (labels.length) {
        labels.pop();
      }

      while (datasets.length) {
        datasets.pop();
      }

      value.value.result[0].retention.forEach((e, idx) => {
        labels.push(`${idx} day`);
      });

      let idx = 0;
      for (const branch of value.value.result) {
        const data = branch.retention;

        datasets.push({
          label: branch.label,
          backgroundColor: colors[idx],
          borderColor: colors[idx++],
          fill: false,
          data,
        });
      }

      try {
        table = Object.fromEntries(value.value.result.map((v) => [
          `${v.label}, %`, v.retention.map((v, idx) => ({ date: `${idx} day`, amount: v.toFixed(1) })),
        ]));
      } catch (e) {}
    }
  });
</script>

<div class="buttons">
  <div class="pc-line">
    <span class="date-label">From</span>
    <input type="date" bind:value={startDate} class="form-control" min="{minDate}" max="{moment(maxDate).subtract(1, 'days').format('YYYY-MM-DD')}" on:input={refresh}>
  </div>
  <div class="pc-line">
    <span class="date-label">To</span>
    <input type="date" bind:value="{endDate}" class="form-control" min="{moment(minDate).add(1, 'days').format('YYYY-MM-DD')}" max="{maxDate}" on:input={refresh}>
  </div>
</div>
<hr>
<div class="buttons">
  <div class="pc-line">
    <span class="date-label">Game</span>
    <select class="form-select" bind:value={creator} on:change={refresh}>
      <option value="all">All</option>
      <option value="Cats">Cats</option>
      <option value="Dragons">Dragons</option>
      <option value="Foxes">Foxes</option>
      <option value="Dogs">Dogs</option>
    </select>
  </div>
  <div class="pc-line">
    <span class="date-label">Only new users?</span>
    <input type="checkbox" bind:checked={onlyNewUsers} on:change={refresh}>
  </div>
</div>
<hr>
<div class="buttons">
  <div class="pc-line">
    <button class="btn btn-primary btn-filter" on:click={refresh}>Refresh</button>
  </div>
</div>
<p class="description">Retention analytics.</p>
<div class="graphic">
  {#if $getRetentionAnalytics.error}
    Something went wrong. Try refreshing the page.
  {:else if $getRetentionAnalytics.loading}
    <div class="graphic-loading">
      <img src="{loader}" alt="">
    </div>
  {:else}
    <Chart bind:this={chart} type="line" {data} width={500} height={270} {optionsLinear} />
    <Table branches={table} isTableHidden={false} hideTotal={true}/>
  {/if}
</div>